export default "__VITE_ASSET__Ph9XZqX9__"